import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'src/constants';
import { useSearchAgents } from 'src/hooks/useSearchAgents';
import ApiService from 'src/modules/api-service';

export const useSearchAgentDeprecated = (id: string | undefined | null) => {
  const { data: searchAgents } = useSearchAgents();
  return searchAgents.find((searchAgent) => searchAgent.id === id);
};

export const useSearchAgent = (id: string | null) =>
  useQuery(
    [QueryKeys.searchAgent, id],
    async () => {
      if (!id) return null;
      const res = await ApiService.searchAgent.searchAgentControllerGetSearchAgent(id);
      return res.data;
    },
    { enabled: !!id },
  );
